import { Accession, LISCaseList } from "pwapi";

import { ModMedPWPayload } from "./objectFromBarcode";

export const compareCaseToModMed = (
  c: LISCaseList | Accession,
  mod_med_payload: ModMedPWPayload,
  comparePatientName: boolean = false
) => {
  return (
    `${c.external_order_id}` === mod_med_payload.external_order_id &&
    (c.patient?.external_patient_id || mod_med_payload.external_patient_id
      ? // Per Jordon, External Patient ID is optional
        // Skip this check if both are absent, if either
        // are available, run the comparison
        `${c.patient?.external_patient_id}` ===
        mod_med_payload.external_patient_id
      : true) &&
    `${c.patient?.medical_record_number}` ===
      mod_med_payload.medical_record_number &&
    (comparePatientName
      ? // Optionally check the patient name
        // This should be true at accessioning, but
        // ... not at Grossing, because the name could
        // have been adjusted by QA, and we still want
        // the barcode to scan
        c.patient?.first_name?.toUpperCase() ===
          mod_med_payload.first_name.toUpperCase() &&
        c.patient?.last_name?.toUpperCase() ===
          mod_med_payload.last_name.toUpperCase()
      : true)
  );
};
